export default "__VITE_ASSET__Dpc0MOKC__"